import Icon from '@heroicons/react/solid/PlusIcon';

import BaseIcon, { IconProps } from './base-icon';

const PlusIcon = (props: IconProps) => {
  return <BaseIcon Icon={Icon} {...props} />;
};

export default PlusIcon;
